import type { AssetsBatchEditReplacementCostProps } from "./assets-batch-edit-replacement-cost.type";

import { useTranslation } from "react-i18next";

import AssetReplacementCostField from "@/modules/asset/asset-replacement-cost-field";
import BatchEditForm from "@/modules/batch-edit-form";

import { useAssetsBatchEditReplacementCost } from "./assets-batch-edit-replacement-cost.hook";

export const AssetsBatchEditReplacementCost = ({
  assets,
}: AssetsBatchEditReplacementCostProps) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useAssetsBatchEditReplacementCost(assets);

  return (
    <BatchEditForm
      modelKey="asset"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
    >
      <AssetReplacementCostField
        name={fieldName}
        inputProps={{
          placeholder: t("asset:batchEdit.replacementCost.placeholder"),
        }}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      />
    </BatchEditForm>
  );
};
